import React from "react";
import { Tooltip, Typography, Space } from "antd";
import {
  getViewersTooltipContent,
  parseViewers,
  calculateTotalViewersCount
} from "@tailormed/common-client/util/savedList";

import { SHARED } from "../constant/savedList";
import { WHITE, BLACK, PRIMARY_25 } from "../constant/colors";
import { fontWeights, sizes } from "../constant/styles";
import { LIST_TYPE_ICONS } from "@tailormed/common-client/constant/savedList";

const { Text } = Typography;

export const ViewersBadge = ({ record, assigneesAndUserGroups, userGroupsWithUsers, t, style }) => {
  const viewers = parseViewers(record.viewers);

  if (record.type !== SHARED || !viewers?.length) {
    return null;
  }

  const totalViewersCount = calculateTotalViewersCount(
    viewers,
    assigneesAndUserGroups,
    userGroupsWithUsers,
    record.user
  );

  return (
    <Tooltip
      overlayClassName="custom-tooltip-saved-list-arrow"
      arrow={{
        pointAtCenter: true
      }}
      autoAdjustOverflow={true}
      overlayInnerStyle={{
        backgroundColor: WHITE,
        color: BLACK,
        borderRadius: 8,
        padding: "8px 10px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        fontSize: sizes.small,
        fontWeight: fontWeights.semibold
      }}
      title={<div>{getViewersTooltipContent(viewers, assigneesAndUserGroups, userGroupsWithUsers, record.user)}</div>}
    >
      <div
        style={{
          padding: "5px 10px",
          fontSize: sizes.small,
          fontWeight: fontWeights.bold,
          cursor: "pointer",
          backgroundColor: PRIMARY_25,
          borderRadius: "100px",
          ...style
        }}
        id="shared_lists_viewers_tag"
      >
        {totalViewersCount} {totalViewersCount === 1 ? t("savedList.viewer") : t("savedList.viewers")}
      </div>
    </Tooltip>
  );
};

export const TypeIconBadge = ({ record }) => {
  const typeOption = LIST_TYPE_ICONS.find((option) => option.value === record.type);

  if (!typeOption) {
    return null;
  }

  return (
    <Tooltip
      overlayInnerStyle={{
        backgroundColor: WHITE,
        color: BLACK,
        borderRadius: 8,
        padding: "10px 15px 0 15px"
      }}
      overlayClassName="custom-tooltip-saved-list custom-tooltip-saved-list-arrow"
      trigger={["hover"]}
      title={
        <Space direction="vertical">
          <Text style={{ color: BLACK, fontWeight: fontWeights.semibold, fontSize: sizes.small }}>
            {typeOption.description}
          </Text>
        </Space>
      }
    >
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
        id={typeOption.id}
      >
        {typeOption.icon}
      </div>
    </Tooltip>
  );
};
